import { useState, useEffect } from 'react';
import { Channel } from 'core/models/channel';
import { cancellable } from './utility/cancellable';

export function useChannelPrepare(channel: Channel | undefined) {
    const [prepared, setPrepared] = useState(false);

    useEffect(() => {
        if (!channel) return;

        return cancellable(async isCanceled => {
            try {
                await channel.prepare();
                if (isCanceled()) return;
                setPrepared(true);
            } catch (e) {
                console.error(`error while connecting media stream: ${JSON.stringify(e)}`);
                // TODO: error handling
            }
        });
    }, [channel, setPrepared]);

    return prepared;
}

export function useChannelStream(channel: Channel | undefined, audio: boolean) {
    const [stream, setStream] = useState<MediaStream>();

    useEffect(() => {
        if (!channel) return;

        return cancellable(async isCanceled => {
            try {
                const stream = await channel.connect({ audio });
                if (isCanceled()) return;
                setStream(stream);
            } catch (e) {
                console.error(`error while connecting media stream: ${JSON.stringify(e)}`);
                // TODO: error handling
            }
        }, () => {
            channel.disconnect();
        });
    }, [channel, audio, setStream]);

    useEffect(() => {
        const currentChannel = channel;
        if (!currentChannel) return;

        const listener = (stream: MediaStream) => {
            setStream(stream);
        };
        currentChannel.addReconnectListener(listener);
        return () => currentChannel.removeReconnectListener(listener);
    }, [channel, setStream]);

    return stream;
}
